//TODO: Implement Label, ShortLabel, Tooltip(Desc)
//TODO: Support submenues

import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';
import { SessionStorage } from '@Core/services/proprietary/browser-storage/session-storage.service';
import { cloneDeep } from 'src/ep-utils';
import { AppConfigService } from './app-config.service';
import { DataService } from './data.service';
import { Datasource, DataSourceStatus } from './datasource';
import { MenuType } from './menu.types';

@Injectable()
export class MenuService {
    // see router-link-extension directive to see where these values are set.   Stored here so that
    // info can be passed to context-menu-modal
    public contextMenuClickedElement = null; //element that was clicked for modal -- put into context menu service?
    public contextMenuCode: string = null;
    public contextMenuData: MenuType = null;
    public contextMenuActionSelectedCallback: any = null;

    constructor(private ds: DataService, private appConfig: AppConfigService, private sessionStorage: SessionStorage) { }

    async getMenu(menuCode: string, forceRefresh: boolean = false, retrieveOnly: boolean = false) {
        return new Promise<MenuType>(async (resolve) => {
            let objectCode = menuCode.split('|')[0];
            let menuType = menuCode.split('|')[1];
            let sig = 'datacache.menu:' + objectCode.toLocaleLowerCase() + '|' + menuType.toLocaleLowerCase();
            let dataString = '';
            let requestedMenu: any = {};

            let dsTempMenu: Datasource;
            let dsTempMenuSub: Subscription;

            if (forceRefresh) {
                this.flushMenuCacheForObject(objectCode);
            } else {
                if (this.appConfig.allowDataCache) {
                    //If specfic objectCode and menuType not found, clear session storage for all menus for the object (just incase)...
                    //...and then retrieve all menuType for the object.
                    dataString = await this.sessionStorage.getItemAsync(sig);
                    if (dataString === null) {
                        this.flushMenuCacheForObject(objectCode);
                    } else {
                        if (!retrieveOnly) {
                            requestedMenu = JSON.parse(dataString);
                            resolve(requestedMenu);
                        } else {
                            resolve(null);
                        }
                        return;
                    }
                }
            }

            dsTempMenu = this.ds.addNewDatasource('Menu', 'NO-CACHE');
            dsTempMenu.maxRowLimiter = false;

            dsTempMenu.getCollection({
                View: 'FULL',
                Object_Code: objectCode,
                Menu_Type: 'ALL'
            });

            dsTempMenuSub = dsTempMenu.status$.subscribe((status) => {
                switch (status) {
                    case DataSourceStatus.Ready:
                        let instanceMenuType = '';
                        if (dsTempMenuSub) {
                            dsTempMenuSub.unsubscribe();
                        }

                        let menu = dsTempMenu.objectNodes;
                        if (dsTempMenu) {
                            this.ds.deleteDatasource(dsTempMenu);
                        }
                        let covertedMenu: any = {};

                        for (var i in menu) {
                            objectCode = menu[i].Object_Code;
                            instanceMenuType = menu[i].Menu_Type;
                            covertedMenu = this.convertMenuStructure(menu[i]);
                            if (this.appConfig.allowDataCache) {
                                sig = 'datacache.menu:' + objectCode.toLocaleLowerCase() + '|' + instanceMenuType.toLocaleLowerCase();
                                this.sessionStorage.setItemAsync(sig, JSON.stringify(covertedMenu));
                            }

                            if (!retrieveOnly) {
                                if (menuType == instanceMenuType) {
                                    requestedMenu = covertedMenu;
                                }
                            }
                        }
                        if (!retrieveOnly) {
                            resolve(requestedMenu);
                            return;
                        } else {
                            resolve(null);
                            return;
                        }

                    case DataSourceStatus.Error:
                        if (dsTempMenu) {
                            this.ds.deleteDatasource(dsTempMenu);
                        }

                        if (dsTempMenuSub) {
                            dsTempMenuSub.unsubscribe();
                        }
                        resolve(null);
                        return;
                }
            });
        });
    }

    convertMenuStructure(menu: any): MenuType {
        let currentGroup: any;
        let currentItem: any;
        let workingItem: any = {};
        let menuItems: any = [];

        for (var g in menu.Menu_Group) {
            currentGroup = menu.Menu_Group[g];
            //Primary group doesn't get a separator in the new structure.
            if (currentGroup.Group_Code != 'Primary') {
                menuItems.push({ Label: currentGroup.Group_Desc, Color: 'bg-orange', Type: 'separator' });
            }
            if (currentGroup.Menu_Items && currentGroup.Menu_Items.Menu_Item) {
                for (var i in currentGroup.Menu_Items.Menu_Item) {
                    workingItem = {};
                    currentItem = cloneDeep(currentGroup.Menu_Items.Menu_Item[i]);
                    workingItem.Label = currentItem.Label;
                    if (currentItem.Tooltip) {
                        workingItem.Tooltip = currentItem.Tooltip;
                    }
                    if (currentItem.Icon) {
                        workingItem.Icon = 'fa ' + currentItem.Icon;
                    }
                    workingItem.Color = '';
                    if (currentItem.URL) {
                        workingItem.Url = JSON.parse(currentItem.URL);
                    }
                    if (currentItem.Object_Code) {
                        workingItem.ObjectCode = currentItem.Object_Code;
                    }
                    if (currentItem.Rules) {
                        workingItem.Rules = JSON.parse(currentItem.Rules);
                    }

                    menuItems.push(workingItem);
                }
            }
        }

        return { objectNode: { Menu_Item: menuItems } };
    }

    async getAppMenus() {
        await this.getMenu('G2|Launch', false, true);
    }

    flushMenuCacheForObject(objectCode) {
        let keyToMatch = 'datacache.menu:' + objectCode.toLocaleLowerCase();
        const cachedMenuKeys = this.sessionStorage.getAllKeys().filter((key) => key.indexOf(keyToMatch) > -1);

        for (const key of cachedMenuKeys) {
            this.sessionStorage.removeItem(key);
        }
    }

    flushMenuCacheAll() {
        this.sessionStorage.removeItemOfType('menu');
    }
}
